import { Alert } from '@efast_public/fjd-component-library';
import { fjdAlertErrorBackendMsg } from './ErrorCode';

interface ErrorComponentBackendProps {
  errorCode?: string;
}

export function ErrorComponentBehoerdenServer(
  props: ErrorComponentBackendProps
): JSX.Element {
  const errorcodeMsg = props.errorCode
    ? ` (${props.errorCode})`
    : ' (Server nicht erreichbar oder fehlerhaft)';

  return (
    <Alert
      variant="error"
      message={fjdAlertErrorBackendMsg.concat(errorcodeMsg)}
    />
  );
}
